// extracted by mini-css-extract-plugin
export default {"publishedByMe__deleteModal":"PublishedByMe_publishedByMe__deleteModal__Rtq-g","publishedByMe__deleteModal__text":"PublishedByMe_publishedByMe__deleteModal__text__BBqER"};